// 配置文件
export const configureKey = {
  all: ['configureKey'] as const
};
